import { RootState } from 'store';

export const getModalState = (store: RootState): boolean => store.system.isModalOpen;
